import { Dialog } from "@headlessui/react";
import { IconX } from "@tabler/icons-react";
import ContractInfoRow from "../../../../components/ContractInfoRow";
import { connect, useDispatch } from "react-redux";
import { getContractRecord } from "../../../../store/contract/actions";
import { ContractScope, ContractState } from "../../../../store/contract/types";
import { FaSpinner } from "react-icons/fa6";
import { RootState } from "../../../../store/root-reducer";
import { isScopeLoading } from "../../../../store/scope-loading/helpers";
import useToggle from "../../../../hooks/useToggle";
import { ContractStatus } from "../../../../store/user/types";
import { formatCurrency, formatDate } from "../../../../helper";
import CancelPlanModal from "./CancelPlanModal";
import { useEffect, useState } from "react";
// import Button from '../../../../components/Button';
import ClaimFileSendEmailModel from "../../../../components/ClaimFileSendEmailModel";
import ContractSubmitTicketModal from "../../../../components/ContractSubmitTicketModal";
import Button from "../../../../components/Button";

const { REACT_APP_FILE_CLAIM_URL } = process.env;

interface ContractViewModalProps {
  isOpen: boolean;
  close: () => void;
  data: any;
  contract: ContractState;
  loading: boolean;
  statusbg: object;
  permissions: string[];
  canFileClaim: boolean;
  canCancelPlan: boolean;
}

function ContractViewModal({
  isOpen,
  close,
  data,
  contract,
  loading,
  statusbg,
  permissions,
  canFileClaim,
  canCancelPlan,
}: ContractViewModalProps) {
  const [openSendEmailModal, setOpenSendEmailModal] = useState(false);
  const [openSubmitTicketModal, setOpenSubmitTicketModal] = useState(false);
  const dispatch = useDispatch();
  const {
    value: showCancelltion,
    setFalse: hideCancelltionModal,
    setTrue: showCancelltionModal,
  } = useToggle(false);

  useEffect(() => {
    if (data.id && contract.id !== data.id) {
      dispatch(getContractRecord(data.id));
    }
  }, [contract.id, data.id, dispatch]);

  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={close}
    >
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/50">
        <div className="flex h-screen overflow-hidden items-center justify-center p-4 ">
          <div className="w-full max-h-full min-h-96 overflow-hidden rounded-xl bg-white max-w-7xl flex flex-col ">
            <div className="flex  items-center justify-between border-b border-gray-200 gap-3 p-3 text-gray-800">
              <h2 className="text-lg font-medium flex items-center gap-3">
                {data.contractNumber || "N/A"}
                {data.status && (
                  <div
                    className={`flex items-center justify-center  py-1 px-3 rounded-2xl text-[12px] h-[28px] ${
                      data.status
                    } ${statusbg[data.status]}`}
                  >
                    <span>{data.status}</span>
                  </div>
                )}
              </h2>
              <button onClick={close}>
                <IconX />
              </button>
            </div>
            {loading ? (
              <div className="flex items-center justify-center h-full flex-1">
                <FaSpinner className="animate-spin text-primary size-8" />
              </div>
            ) : (
              <div className="space-y-4 my-4 overflow-y-auto h-full container">
                <div className="space-y-1">
                  <div className="flex justify-between items-center">
                    <p className="font-medium text-black">
                      Purchase Information
                    </p>
                    <div className="flex space-x-1">
                      {canFileClaim &&
                        data.status === ContractStatus.Active && (
                          <Button
                            variant="blue"
                            onClick={() =>
                              window.open(
                                `${REACT_APP_FILE_CLAIM_URL}/${data.id}`,
                                "_blank",
                                "noreferrer"
                              )
                            }
                          >
                            File Claim
                          </Button>
                        )}
                      <Button
                        variant="gray"
                        onClick={() => {
                          setOpenSendEmailModal(true);
                        }}
                      >
                        Send Claim Page To Customer
                      </Button>
                      <Button
                        variant="blue"
                        onClick={() => {
                          setOpenSubmitTicketModal(true);
                        }}
                      >
                        Submit Ticket
                      </Button>
                      {permissions.includes("cancel:contract") &&
                        data.status === ContractStatus.Active && (
                          <button
                            className={`bg-red-100 text-red-400 border border-red-400 rounded-md px-2 py-2.5 leading-[normal] transition-all ${
                              canCancelPlan
                                ? "hover:text-white hover:bg-red-500"
                                : "opacity-50 cursor-not-allowed"
                            }`}
                            onClick={
                              canCancelPlan ? showCancelltionModal : undefined
                            }
                            disabled={!canCancelPlan}
                          >
                            Cancel Plan
                          </button>
                        )}
                    </div>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 gap-x-5 gap-y-3 grid min-[640px]:grid-cols-2 grid-cols-1">
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Delivery Date"
                      value={contract.deliveryDate}
                      isDate
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Purchase Date"
                      value={contract.purchaseDate}
                      isDate
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Reg Date"
                      value={contract.regDate}
                      isDate
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Expiration Date"
                      value={contract.expirationDate}
                      isDate
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Expired"
                      value={contract.expired}
                      isBoolean
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Status"
                      value={contract.status}
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Plan Program Price"
                      value={contract.warrantyProgramPrice}
                      isCurrency
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[170px]"
                      label="Plan SKU"
                      value={contract.warrantyProgram}
                    />
                    {contract.TCFileLink && (
                      <ContractInfoRow
                        labelClassName="min-w-[170px]"
                        label="Plan Agreement"
                        isLink
                        linkText="View PDF"
                        value={contract.TCFileLink}
                      />
                    )}
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="font-medium text-black">Customer Information</p>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 space-y-4">
                    <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer First Name"
                        value={contract.customerFirstName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Last Name"
                        value={contract.customerLastName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Email"
                        value={contract.customerEmail}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Phone"
                        value={contract.customerPhone}
                        isPhone
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Alternative Telephone"
                        value={contract.customerAlternatePhone}
                        isPhone
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer ID"
                        value={contract.customerId}
                      />
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Customer Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.customerAddress1}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Address Line 2"
                          value={contract.customerAddress2}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.customerCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.customerState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.customerZip}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Delivery Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.deliveryAddress1}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Address Line 2"
                          value={contract.deliveryAddress2}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.deliveryCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.deliveryState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.deliveryState}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="font-medium text-black">Store Information</p>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 space-y-4">
                    <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Store Name"
                        value={contract.storeName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Salesperson ID"
                        value={contract.salesPerson}
                      />
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Store Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.storeAddress1}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.storeCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.storeState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.storeZip}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="font-medium text-black">Line Items</p>
                  <div className="overflow-hidden rounded-[10px] border border-gray-300 bg-white ">
                    <div className="overflow-auto">
                      <table className="w-full min-w-[800px]">
                        <thead>
                          <tr>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Item Type
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Item Description
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Manufacturer
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Material
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Color
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Model Number
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Delivery Date
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Retail Price
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Vendor
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Serial Number
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {contract.lineItems.length > 0 ? (
                            contract.lineItems.map((item, index) => (
                              <tr key={item.id}>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.itemType || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.itemDescription || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.manufacturer || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.material || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.color || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.modelNumber || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {formatDate(item.deliveryDate, "N/A")}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {formatCurrency(item.retailerPrice)}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.vendor || "N/A"}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.serialNumber || "N/A"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={11}
                                className="px-3 py-8 text-sm text-gray-600 border-t border-gray-200 text-center"
                              >
                                No line items found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {openSendEmailModal && (
                  <ClaimFileSendEmailModel
                    isOpen={openSendEmailModal}
                    onClose={() => setOpenSendEmailModal(false)}
                    customerEmail={contract.customerEmail || ""}
                    customerPhone={
                      contract.customerPhone ||
                      contract.customerAlternatePhone ||
                      ""
                    }
                    planId={data.id}
                    contactId={contract.contactId}
                  />
                )}
                {openSubmitTicketModal && (
                  <ContractSubmitTicketModal
                    isOpen={openSubmitTicketModal}
                    onClose={() => setOpenSubmitTicketModal(false)}
                  />
                )}
              </div>
            )}
            <CancelPlanModal
              onSucessClose={close}
              isOpen={showCancelltion}
              onClose={hideCancelltionModal}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state: RootState) => ({
  contract: state.contract,
  loading: isScopeLoading(state.scopeLoading, ContractScope),
  permissions: state?.user.selectedOrg.permissions || [],
  canFileClaim: state?.user.selectedOrg.can_file_claim || false,
  canCancelPlan: state?.user.selectedOrg.can_cancel_plan ?? true,
});

export default connect(mapStateToProps)(ContractViewModal);
